/* eslint-disable eqeqeq */
import { useNavigate } from 'react-router-dom';
import {
  basicServices,
  IBooking,
  ICreateBooking,
  ICreateServiceDetails,
  INewBooking,
  IService,
  IServiceDetails,
  IUser,
  IUserAddress,
} from '../../utils/entities/interface';
import {
  Autocomplete,
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import {
  Add,
  ArrowBack,
  ArrowForward,
  Edit,
  Person,
  Phone,
} from '@mui/icons-material';
import ServiceDropdown from '../../components/common/ServiceDropDown';
import { ACList } from '../../components/common/ACItems';
import { CommercialACForm } from '../../components/common/CommercialAcfrom';
import { AMCForm } from '../../components/common/AmcForm';
import CreateUserComp from '../../components/ui/add/user';
import React, { useEffect, useState } from 'react';
import { GetAdresses, GETUsers } from '../../services/users';
import SideDrawer from '../../components/atoms/Drawer';
import { capitalizeWords, isoToDateString } from '../../utils/helper';
// import { OtherServiceForm } from '../../components/common/Others';
import styled from '@emotion/styled';
import { AddressForm } from '../../components/ui/add/address';

export const DateField = styled(TextField)({
  '& input[type="date"]::-webkit-calendar-picker-indicator': {
    filter: 'invert(1)', // Invert colors to make the icon white
  },
});

export const TimeField = styled(TextField)({
  '& input[type="time"]::-webkit-calendar-picker-indicator': {
    cursor: 'pointer',
  },
  '& input[type="time"]': {
    colorScheme: 'dark',
    color: '#fff',
  },
});

export const BookingDetails = ({
  booking,
  mode,
  selectedService,
  setMode,
  setSelectedService,
  selectedSlot,
  setSelectedSlot,
  setDirtyBooking,
  dirtyBooking,
}: {
  booking: IBooking | null;
  dirtyBooking: ICreateBooking;
  mode: 'add' | 'edit' | 'view';
  selectedSlot: 'FIRST_HALF' | 'SECOND_HALF';
  selectedService: IService[] | null;
  setMode: React.Dispatch<React.SetStateAction<'add' | 'edit' | 'view'>>;
  setSelectedSlot: React.Dispatch<
    React.SetStateAction<'FIRST_HALF' | 'SECOND_HALF'>
  >;
  setSelectedService: React.Dispatch<React.SetStateAction<IService[] | null>>;
  setDirtyBooking: React.Dispatch<React.SetStateAction<ICreateBooking>>;
}) => {
  const navigate = useNavigate();
  const [date, setDate] = useState<string | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSlotChange = (event: any) => {
    if (mode == 'add' || mode == 'edit') {
      setDirtyBooking((p) => ({ ...p, slot: event.target.value }));
      setSelectedSlot(event.target.value);
    }
  };

  const address = booking?.addressDetails[0];

  console.log('booking', booking);
  return (
    <>
      <Box
        sx={{
          padding: 2,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: '#1E1E1E',
        }}
      >
        {mode === 'add' ? (
          <>
            <SelectUser setDirtyBooking={setDirtyBooking} />
          </>
        ) : (
          <>
            <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
              <Person sx={{ color: '#BB86FC', marginRight: 1 }} />
              <Typography sx={{ color: '#B0BEC5' }}>
                {capitalizeWords(booking?.user.name as string) || 'N/A'}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
              <Phone sx={{ color: '#BB86FC', marginRight: 1 }} />
              <Typography sx={{ color: '#B0BEC5' }}>
                {booking?.user.phoneNumber}
              </Typography>
            </Box>
          </>
        )}
      </Box>
      <Typography variant="h6" sx={{ mt: 2, mb: 0.5, color: '#E0E0E0' }}>
        Booking Service
      </Typography>
      <ServiceDropdown
        mode={mode}
        setSelected={setSelectedService}
        disabled={mode == 'view'}
        setDirtyBooking={setDirtyBooking}
        selected={selectedService}
      />

      <Typography variant="h6" sx={{ mt: 2, mb: 0.5, color: '#E0E0E0' }}>
        Booking Date
      </Typography>
      <DateField
        type="date"
        value={
          mode == 'view'
            ? booking &&
              booking.date &&
              isoToDateString(booking?.date as string)
            : date
        }
        onChange={(e) => {
          setDate(e.target.value);
          if (mode === 'add' || mode == 'edit') {
            setDirtyBooking((prev) => ({ ...prev, date: e.target.value }));
          }
        }}
        disabled={mode == 'view'}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          input: { color: '#B0BEC5' },
          label: { color: '#B0BEC5' },
        }}
        variant="outlined"
      />

      <Typography variant="h6" sx={{ mt: 2, mb: 0.5, color: '#E0E0E0' }}>
        Booking Slot
      </Typography>
      <ToggleButtonGroup
        value={selectedSlot}
        exclusive
        onChange={handleSlotChange}
        disabled={mode == 'view'}
      >
        <ToggleButton
          value="FIRST_HALF"
          sx={{
            color: '#B0BEC5',
            '&.Mui-selected': {
              backgroundColor: '#BB86FC',
              color: '#FFFFFF',
            },
          }}
        >
          {/* First Half (Morning) */}
          First Half
        </ToggleButton>
        <ToggleButton
          value="SECOND_HALF"
          sx={{
            color: '#B0BEC5',
            '&.Mui-selected': {
              backgroundColor: '#BB86FC',
              color: '#FFFFFF',
            },
          }}
        >
          {/* Second Half (Afternoon) */}
          Second Half
        </ToggleButton>
      </ToggleButtonGroup>
      <ServiceAddress
        mode={mode}
        userId={booking ? booking?.user._id : dirtyBooking.user_id}
        setDirtyBooking={setDirtyBooking}
        assignedAddressID={
          booking ? booking?.addressDetails[0]._id : dirtyBooking.addressId
        }
        assgiendAddress={booking && booking.addressDetails}
      />
    </>
  );
};

export const ServiceDetails = ({
  selectedService,
  mode,
  details,
  setDirtyBooking,
}: {
  selectedService: IService[] | null;
  details: IServiceDetails[] | ICreateServiceDetails[] | undefined;
  mode: 'add' | 'edit' | 'view';
  setDirtyBooking: React.Dispatch<React.SetStateAction<ICreateBooking>>;
}) => {
  const [currentIndex, setCurrentIndex] = useState(0); // State to manage the current service index

  useEffect(() => {
    setCurrentIndex(0);
  }, [selectedService]);

  if (!selectedService || selectedService.length === 0) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="90%"
        mb={2}
        p={1}
        border={1}
        borderColor="rgba(255, 255, 255, 0.12)"
        borderRadius={4}
        bgcolor="#1E1E1E"
      >
        <Typography sx={{ color: 'gray', opacity: 0.6 }}>
          Please select a service to view details.
        </Typography>
      </Box>
    );
  }

  const currentService = selectedService[currentIndex];

  // Function to handle key press for navigation
  const handleArrowKey = (event: React.KeyboardEvent) => {
    if (event.key === 'ArrowRight') {
      // Next service
      setCurrentIndex((prevIndex) =>
        Math.min(prevIndex + 1, selectedService.length - 1),
      );
    } else if (event.key === 'ArrowLeft') {
      // Previous service
      setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    }
  };

  return (
    <Box
      onKeyDown={handleArrowKey}
      tabIndex={0}
      height={'100%'}
      overflow={'auto'} // Make sure the Box is focusable to receive key events
      sx={{ scrollbarWidth: 'none' }}
    >
      {/* Navigation arrows with service name */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        border={1}
        borderRadius={4}
        bgcolor="#1E1E1E"
        borderColor="rgba(255, 255, 255, 0.12)"
        mb={1}
        sx={{
          gap: '16px',
        }}
      >
        {/* Previous Button */}
        <IconButton
          onClick={() =>
            setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0))
          }
          disabled={currentIndex === 0}
          sx={{
            color: currentIndex === 0 ? 'gray' : 'primary.main',
          }}
        >
          <ArrowBack />
        </IconButton>

        {/* Service Name Display */}
        <Typography variant="h6" sx={{ flex: 1, textAlign: 'center' }}>
          {currentService?.name}
        </Typography>

        {/* Next Button */}
        <IconButton
          onClick={() =>
            setCurrentIndex((prevIndex) =>
              Math.min(prevIndex + 1, selectedService.length - 1),
            )
          }
          disabled={currentIndex === selectedService.length - 1}
          sx={{
            color:
              currentIndex === selectedService.length - 1
                ? 'gray'
                : 'primary.main',
          }}
        >
          <ArrowForward />
        </IconButton>
      </Box>
      {currentService && (
        <>
          {currentService.key === 'SERVICE' && (
            <ACList
              disabled={mode === 'view'}
              details={details}
              setDirtyBooking={setDirtyBooking}
              service={currentService}
            />
          )}
          {currentService.key === 'REPAIR' && (
            <ACList
              disabled={mode === 'view'}
              details={details}
              setDirtyBooking={setDirtyBooking}
              service={currentService}
            />
          )}
          {currentService.key === 'INSTALLATION' && (
            <ACList
              disabled={mode === 'view'}
              details={details}
              setDirtyBooking={setDirtyBooking}
              service={currentService}
            />
          )}
          {currentService.key === 'COMPRESSOR' && (
            <ACList
              disabled={mode === 'view'}
              details={details}
              setDirtyBooking={setDirtyBooking}
              service={currentService}
            />
          )}
          {currentService.key === 'GAS_CHARGING' && (
            <ACList
              disabled={mode === 'view'}
              details={details}
              setDirtyBooking={setDirtyBooking}
              service={currentService}
            />
          )}
          {/* {currentService.key === 'COMMERCIAL_AC' && (
            <CommercialACForm
              disabled={mode === 'view'}
              details={
                Array.isArray(details)
                  ? details?.filter(
                      (data) => currentService._id == data.service_id,
                    )
                  : []
              }
              setDirtyBooking={setDirtyBooking}
              service={currentService}
            />
          )} */}
          {/* {currentService.key === 'AMC' && (
            <AMCForm
              disabled={mode === 'view'}
              details={
                Array.isArray(details)
                  ? details?.filter(
                      (data) => currentService._id == data.service_id,
                    )
                  : []
              }
              setDirtyBooking={setDirtyBooking}
              service={currentService}
            />
          )}
          {currentService.key === 'COPPER_PIPING' && (
            <AMCForm
              disabled={mode === 'view'}
              details={
                Array.isArray(details)
                  ? details?.filter(
                      (data) => currentService._id == data.service_id,
                    )
                  : []
              }
              setDirtyBooking={setDirtyBooking}
              service={currentService}
            />
          )} */}
          {/* {currentService.key == 'OTHER' && (
            <OtherServiceForm
              disabled={mode === 'view'}
              details={
                Array.isArray(details)
                  ? details?.filter(
                      (data) => currentService._id == data.service_id,
                    )
                  : []
              }
              setDirtyBooking={setDirtyBooking}
              service={currentService}
            />
          )} */}
        </>
      )}
    </Box>
  );
};
const SelectUser = ({
  setDirtyBooking,
}: {
  setDirtyBooking: React.Dispatch<React.SetStateAction<ICreateBooking>>;
}) => {
  const [userOptions, setUserOptions] = useState<IUser[]>([]);
  const [selectedUser, setSelectedUser] = useState<IUser | null>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const fetchUsers = async () => {
    try {
      const response = await GETUsers({ page: 1, limit: 10000 });
      setUserOptions(response.data); // Ensure response.data conforms to IUser[]
    } catch (error) {
      console.error('Failed to fetch users:', error);
    }
  };

  const handleOpenDrawer = () => {
    setDrawerOpen(true);
  };

  const handleCloseDrawer = async () => {
    setDrawerOpen(false);
  };

  useEffect(() => {
    fetchUsers();
  }, [drawerOpen]);

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Autocomplete
        options={userOptions}
        getOptionLabel={(option) =>
          `${capitalizeWords(option.name)} (${option.phoneNumber.slice(0, 10)})`
        } // Display name and phone number
        value={selectedUser}
        onChange={(event, newValue) => {
          setSelectedUser(newValue);
          setDirtyBooking((prev) => ({
            ...prev,
            user_id: newValue?._id as string, // Set userId from selected user
          }));
        }}
        sx={{
          flex: 1,
          '& .MuiAutocomplete-listbox': {
            '&::-webkit-scrollbar': {
              display: 'none', // Hides scrollbar for webkit browsers
            },
            '&::-moz-scrollbar': {
              display: 'none', // Hides scrollbar for Firefox
            },
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select User"
            variant="outlined"
            sx={{
              input: { color: '#B0BEC5' },
              label: { color: '#B0BEC5' },
            }}
          />
        )}
      />
      <Button
        variant="outlined"
        color="primary"
        sx={{ height: 56 }}
        onClick={handleOpenDrawer}
      >
        New
      </Button>
      <SideDrawer
        open={drawerOpen}
        onClose={handleCloseDrawer}
        renderHeader="Add User"
        renderComponent={
          <CreateUserComp
            onSaved={handleCloseDrawer}
            handleDrawerClose={handleCloseDrawer}
          />
        }
        size="sm" // You can change the size as needed
      />
    </Box>
  );
};

const ServiceAddress = ({
  mode,
  userId,
  assignedAddressID,
  setDirtyBooking,
  assgiendAddress,
}: {
  mode: 'add' | 'edit' | 'view';
  assgiendAddress: IUserAddress | any;
  assignedAddressID: string | null | undefined;
  userId: string | undefined;
  setDirtyBooking: React.Dispatch<React.SetStateAction<ICreateBooking>>;
}) => {
  const [currAddress, setcurrAddress] = useState<IUserAddress>();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isAddingNewAddress, setIsAddingNewAddress] = useState(false);

  useEffect(() => {
    if (assignedAddressID && userId && assgiendAddress) {
      setcurrAddress(assgiendAddress[0]);
    }
  }, [mode, userId, assignedAddressID]);

  const handleChangeAddress = (address: IUserAddress) => {
    setDirtyBooking((p) => ({
      ...p,
      addressId: address._id,
    }));
    setcurrAddress(address);
    handleCloseDrawer();
  };

  const handleAddAddress = (newAddress: any) => {
    handleCloseDrawer();
  };

  const handleCloseDrawer = async () => {
    setDrawerOpen(false);
  };

  const handleOpenDrawer = async () => {
    setIsAddingNewAddress(false);
    setDrawerOpen(true);
  };
  const openAddNewAddressForm = () => {
    setIsAddingNewAddress(true);
    setDrawerOpen(true);
  };
  return (
    <>
      {/* Service Address Header with Change Icon */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mt: 2, mb: 0.5 }}
      >
        <Typography variant="h6" sx={{ color: '#E0E0E0' }}>
          Service Address
        </Typography>

        {mode != 'view' && (
          <Box>
            <IconButton
              onClick={openAddNewAddressForm}
              sx={{ color: '#BB86FC' }}
            >
              <Add />
            </IconButton>
            <IconButton onClick={handleOpenDrawer} sx={{ color: '#BB86FC' }}>
              <Edit />
            </IconButton>
          </Box>
        )}
      </Box>

      {/* Address Details */}
      {currAddress ? (
        <Box sx={{ color: 'gray' }}>
          <Typography variant="body2">
            {currAddress.house}, {currAddress.street}
          </Typography>
          <Typography variant="body2">
            {currAddress.city}, {currAddress.state} {currAddress.zipcode}
          </Typography>
        </Box>
      ) : (
        <Typography variant="body2" sx={{ color: '#B0BEC5' }}>
          No address added yet.
        </Typography>
      )}

      <SideDrawer
        open={drawerOpen}
        onClose={handleCloseDrawer}
        renderHeader={`Select Address`}
        renderComponent={
          isAddingNewAddress && userId ? (
            <AddressForm
              userId={userId}
              onSave={handleAddAddress}
              onClose={handleCloseDrawer}
            />
          ) : userId ? (
            <AddressList
              userId={userId}
              onSelectAddress={handleChangeAddress}
              selectedAddressId={currAddress?._id}
            />
          ) : (
            <Typography
              color="gray"
              flex={1}
              textAlign={'center'}
              marginTop={10}
            >
              Kindly Select User First
            </Typography>
          )
        }
        size="sm" // You can change the size as needed
      />
    </>
  );
};

interface AddressListProps {
  userId: string;
  onSelectAddress: (address: IUserAddress) => void;
  selectedAddressId: string | undefined;
}
const AddressList = ({
  userId,
  onSelectAddress,
  selectedAddressId,
}: AddressListProps) => {
  const [addresses, setAddresses] = useState<IUserAddress[]>([]);

  useEffect(() => {
    fetchAddresses();
  }, [userId]);

  const fetchAddresses = async () => {
    const response = await GetAdresses(userId);
    setAddresses(response.data);
  };

  const handleSelectAddress = (address: IUserAddress) => {
    onSelectAddress(address);
  };
  return (
    <Box flex={1}>
      <List>
        {addresses.map((address) => (
          <ListItem key={address._id} disablePadding>
            <ListItemButton
              selected={selectedAddressId === address._id}
              onClick={() => handleSelectAddress(address)}
              sx={{
                backgroundColor:
                  selectedAddressId === address._id
                    ? 'primary.main'
                    : 'background.paper',
                color:
                  selectedAddressId === address._id ? 'white' : 'text.primary',
                '&:hover': {
                  backgroundColor:
                    selectedAddressId === address._id
                      ? 'primary.dark'
                      : 'action.hover',
                },
                borderRadius: 1,
                mb: 1,
                boxShadow: 1,
              }}
            >
              <ListItemText
                primary={
                  <Typography
                    variant="body1"
                    fontWeight={
                      selectedAddressId === address._id ? 'bold' : 'normal'
                    }
                  >
                    {`${address.house}, ${address.street}`}
                  </Typography>
                }
                secondary={`${address.city}, ${address.state} - ${address.zipcode}`}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
